import { makeStyles } from '@mui/styles';
import { APP_ACTION_COLUMNS } from '../../utils/constants';
const styles = makeStyles(() => ({
  customTool: {
    marginLeft: '12px',
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    cursor: 'pointer',
    marginTop: '10px'
  },
  importLabel: {
    fontWeight: 700,
    fontSize: '0.875rem',
    cursor: 'pointer',
    display: 'none'
  },
  dialogModal: {
    '& .MuiPaper-root': {
      marginLeft: '10px',
      '& > div:first-child': {
        padding: '4px 11px !important',
      },
      maxWidth: '800px',
    },
    '& .MuiTypography-subtitle1': {
      fontSize: '1.3rem',
      fontWeight: 'bold',
    }
  },
  invalidRow: {
    backgroundColor: '#ffcccc !important'
  },
  disableIcon: {
    pointerEvents: 'none',
    color: 'rgba(0, 0, 0, 0.26)'
  },
  rowViewMode: {
    '& .MuiDataGrid-cell': {
      pointerEvents: 'none',
    },
    ...Object.fromEntries(
      APP_ACTION_COLUMNS.map((field) => [
          `& .MuiDataGrid-cell[data-field="${field}"]`,
          {
            pointerEvents: 'auto',
          },
      ])
    ),
  },
}));
export default styles;
